import React, { useEffect, useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import LazyLoad from "react-lazyload";
import { getCurrentLocale } from "../../../../store/intl/intlSelectors";
import { connect } from "react-redux";
import LottiePlayer from "@lottiefiles/lottie-player";
// components
import Contact from "./Contact";
import WeAreQrCards from "./WeAreQrCards";
import FeaturesGrid from "./FeaturesGrid";
// import Form from "./Form";
import Testimonial from "./Testimonial";
import Features2 from "./Features2";
import Features from "./Features";
// import DevelopmentPlan from "./DevelopmentPlan";
import Presale from "./Presale";
import BuyNow from "./BuyNow";
import UsesOfQrCodes from "./UsesOfQrCodes";
import DynamicQrCodes from "./DynamicQrCodes";
import MainVideo from "./MainVideo";
import Header from "./Header";

const Content = ({ currentLocale }) => {
  const [partOfVideo0, setPartOfVideo0] = useState(null);
  const [partOfVideo1, setPartOfVideo1] = useState(null);
  const [partOfVideo2, setPartOfVideo2] = useState(null);
  const timeoutId = useRef([null, null, null]);
  const duration = [
    [6500, 13000, 20000, 20000],
    [4000, 4000, 4000, 4000, 4000, 4000, 4000, 4000],
    [5000, 5000, 5000, 5000],
  ];

  // optimize image contrast in lottie animations for chrome
  useEffect(() => {
    setTimeout(() => {
      const lotties = document.querySelectorAll("lottie-player");
      lotties.forEach((lottie) => {
        if (lottie.shadowRoot) {
          let images = lottie.shadowRoot.querySelectorAll("image");
          images.forEach((image) => {
            image.style.imageRendering = "-webkit-optimize-contrast";
          });
        }
      });
    }, 1000);
  }, []);
  useEffect(()=> {
    // sendinblue messenger
    (function(d, w, c) {
      w.SibConversationsID = '612cb6f9f9ef0c712e4e757d';
      w[c] = w[c] || function() {
          (w[c].q = w[c].q || []).push(arguments);
      };
      var s = d.createElement('script');
      s.async = true;
      s.src = 'https://conversations-widget.sendinblue.com/sib-conversations.js';
      if (d.head) d.head.appendChild(s);
  })(document, window, 'SibConversations');

  (function() {
    window.sib = {
        equeue: [],
        client_key: "98ahcm025jegcfi1a7jdb7ex"
    };
    /* OPTIONAL: email for identify request*/
    // window.sib.email_id = 'example@domain.com';
    window.sendinblue = {};
    for (var j = ['track', 'identify', 'trackLink', 'page'], i = 0; i < j.length; i++) {
    (function(k) {
        window.sendinblue[k] = function() {
            var arg = Array.prototype.slice.call(arguments);
            (window.sib[k] || function() {
                    var t = {};
                    t[k] = arg;
                    window.sib.equeue.push(t);
                })(arg[0], arg[1], arg[2], arg[3]);
            };
        })(j[i]);
    }
    var n = document.createElement("script"),
        i = document.getElementsByTagName("script")[0];
    n.type = "text/javascript";
    n.id = "sendinblue-js";
    n.async = !0;
    n.src = "https://sibautomation.com/sa.js?key=" + window.sib.client_key;
    i.parentNode.insertBefore(n, i);
    window.sendinblue.page();
})()
  },[])

  function startTimeline(id) {
    const max = duration[id].length;
    function recursiveF(index) {
      if (index > max - 1) {
        recursiveF(0);
        return;
      }
      if (id === 0) {
        resetAnimation(index, id);
      }
      setPartOfVideo(id, index);
      clearTimeout(timeoutId.current[id]);
      timeoutId.current[id] = setTimeout(() => {
        recursiveF(index + 1);
      }, duration[id][index]);
    }
    recursiveF(0);
  }

  function resetAnimation(index, id, stop = false) {
    if (id === 0) {
      const currentVideo = document.querySelector(
        `#video-wrapper .video${index}`
      );
      if (currentVideo) {
        currentVideo.stop();
        currentVideo.play();
      }
    }

    const bar = document.querySelector(`.timeline${id} .bar`);
    const undesirableClass = bar.classList[1];
    const stopClass = bar.classList[2];
    bar.classList.remove(undesirableClass);
    bar.classList.remove(stopClass);
    void bar.offsetWidth;
    bar.classList.add(undesirableClass);
    const max = duration[id].length;
    if (stop) {
      bar.classList.add("stopped");
    }

    clearTimeout(timeoutId.current[id]);
    if (!stop) {
      timeoutId.current[id] = setTimeout(() => {
        if (index > max - 1) {
          setPartOfVideo(id, 0);
          resetAnimation(0, id);
          return;
        }
        if (index < max) {
          setPartOfVideo(id, index + 1);
          resetAnimation(index + 1, id);
        }
      }, duration[id][index]);
    }
  }
  function setPartOfVideo(id, nextIndex) {
    switch (id) {
      case 0: {
        setPartOfVideo0(nextIndex);
        break;
      }
      case 1: {
        setPartOfVideo1(nextIndex);
        break;
      }
      case 2: {
        setPartOfVideo2(nextIndex);
        break;
      }
      // no default
    }
  }

  useEffect(() => {
    function handlePageEvents() {
      const timeline0 = document
        .querySelector(".timeline0")
        .getBoundingClientRect();
      const timeline1 = document
        .querySelector(".timeline1")
        .getBoundingClientRect();
      const timeline2 = document
        .querySelector(".timeline2")
        .getBoundingClientRect();
      if (
        (timeline0.top - window.innerHeight < 0) &
        (timeline0.top - window.innerHeight > -200) &
        (timeoutId.current[0] === null)
      ) {
        setTimeout(() => {
          startTimeline(0);
        }, 500);
      }
      if (
        (timeline1.top - window.innerHeight < 0) &
        (timeoutId.current[1] === null)
      ) {
        setTimeout(() => {
          startTimeline(1);
        }, 500);
      }
      if (
        (timeline2.top - window.innerHeight < 0) &
        (timeoutId.current[2] === null)
      ) {
        setTimeout(() => {
          startTimeline(2);
        }, 500);
      }
    }
    window.addEventListener("scroll", handlePageEvents);
    window.addEventListener("load", handlePageEvents);
    return () => {
      window.removeEventListener("scroll", handlePageEvents);
      window.removeEventListener("load", handlePageEvents);
    };
  });

  //// TODO: Function causing problem with css when user goes to login page or dashboard. Commented for future use if needed.
  // useEffect(() => {
  //   try {
  //     //remove conflicting stylesheets
  //     document
  //       .querySelectorAll('style,link[rel="stylesheet"]')
  //       .forEach((item) => {
  //         if (
  //           item.innerText.includes("Bootstrap") ||
  //           item.innerText.includes("GlobalAppStyles")
  //         ) {
  //           item.remove();
  //         }
  //       });
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }, []);

  function setChatbotHeight(id) {
    // set resizeObserver for chatbots
    const chatbot = document.getElementById(id);
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        // const contentHeight = entry.contentBoxSize[0].blockSize;
        const contentHeight = entry.contentRect.height;
        chatbot.style.height = contentHeight + "px";
      });
    });
    chatbot.contentWindow.document.body.style.margin = "0";
    resizeObserver.observe(
      chatbot.contentWindow.document.querySelector("html")
    );
  }
  return (
    <>
      <Header currentLocale={currentLocale} />
      <MainVideo
        partOfVideo0={partOfVideo0}
        setPartOfVideo0={setPartOfVideo0}
        resetAnimation={resetAnimation}
        currentLocale={currentLocale}
      />
      <Features currentLocale={currentLocale} />
      <FeaturesGrid />
      <LazyLoad className="chatbot-wrapper blue-wave" once offset={1000}>
        <iframe
          id="chatbot1"
          onLoad={() => setChatbotHeight("chatbot1")}
          className="chatbot default-chatbot"
          src={`./chatbots/${currentLocale}/chatbot1.html`}
          frameborder="0"
        ></iframe>
      </LazyLoad>
      {/* <Form /> */}
      {/* <DevelopmentPlan /> */}
      <div className="blue-section">
        <Features2 currentLocale={currentLocale} />
        <UsesOfQrCodes
          partOfVideo1={partOfVideo1}
          setPartOfVideo1={setPartOfVideo1}
          resetAnimation={resetAnimation}
          currentLocale={currentLocale}
          timeoutId={timeoutId}
        />
        <DynamicQrCodes
          partOfVideo2={partOfVideo2}
          setPartOfVideo2={setPartOfVideo2}
          resetAnimation={resetAnimation}
          timeoutId={timeoutId}
          currentLocale={currentLocale}
        />
        <Presale />
        <LazyLoad className="chatbot-wrapper blue" once offset={1000}>
          <iframe
            id="chatbot2"
            onLoad={() => setChatbotHeight("chatbot2")}
            onClick={() => setChatbotHeight("chatbot2")}
            className="chatbot default-chatbot"
            src={`./chatbots/${currentLocale}/chatbot2.html`}
            frameborder="0"
          ></iframe>
        </LazyLoad>
        <BuyNow currentLocale={currentLocale} />
      </div>
      <Testimonial />
      <WeAreQrCards />
      <Contact
        currentLocale={currentLocale}
        setChatbotHeight={setChatbotHeight}
      />
    </>
  );
};
const mapState = (state) => ({
  currentLocale: getCurrentLocale(state),
});

export default withRouter(connect(mapState)(Content));
